import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const ProductAudit = {
  type: 'Product',
  formTitle: 'Product Audit',
  formUrl: '/Products/ProductAudit/Form',
  workspaceUrl: '/menu/Products',
  screenReference: 'PRODUCTS_AUDIT',
  operations: ALLOW_VIEW,
};

export default ProductAudit;
